module.exports = __webpack_public_path__ + "static/media/Android.0ea6f90d.svg";